module.exports = __webpack_public_path__ + "img/performance-test-icon1.470d3c1c.png";